module.exports = __webpack_public_path__ + "static/media/adventureGroupSizeIcon.c3bf9a21.png";